import DashboardCalendar from './DashboardCalendar';

export default DashboardCalendar;
